// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"5ad6fb2c","239":"d3375b1f","453":"d0044cd6","732":"2930c74d","879":"3d3e2027","977":"9052f2ae"}[chunkId] + ".chunk.js";
};